var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c(
        "v-layout",
        { attrs: { flex: "", "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", lg10: "", xl8: "" } },
            [
              _c(
                "v-layout",
                {
                  attrs: { flex: "", "align-center": "", "justify-center": "" }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md12: "" } },
                    [
                      _c(
                        "div",
                        { attrs: { id: "terms-title" } },
                        [
                          _c("page-title", {
                            staticStyle: { "margin-bottom": "8px" },
                            attrs: { title: "Willkommen" }
                          }),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "text-align": "center" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.addressInfo.name))]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.addressInfo.subname))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.addressInfo.street))
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.addressInfo.zipAndPlace))
                            ]),
                            _vm._v(" "),
                            _c("br")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("message-special-situation")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "welcomeDivider" }),
              _vm._v(" "),
              _c("div", { staticClass: "headerListSection" }, [
                _c(
                  "h1",
                  {
                    staticClass: "title text--darken-1",
                    staticStyle: {
                      "text-align": "center",
                      "margin-bottom": "8px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.welcomeTextHeader) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "subtitle-2 text--darken-1",
                    staticStyle: { "text-align": "center" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.welcomeTextSubHeader) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("v-divider", { staticClass: "welcomeDivider" }),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    id: "action-list",
                    flex: "",
                    "align-center": "",
                    "justify-center": ""
                  }
                },
                [
                  _c(
                    "v-list",
                    { attrs: { "two-line": "" } },
                    [
                      _vm._l(_vm.items, function(item, index) {
                        return [
                          item.header
                            ? _c(
                                "v-subheader",
                                { key: item.header },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        flex: "",
                                        "align-center": "",
                                        "justify-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "", md10: "" } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.header) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : item.divider
                            ? _c("v-divider", {
                                key: index,
                                staticClass: "welcomeDivider",
                                attrs: { inset: item.inset }
                              })
                            : _c(
                                "v-list-tile",
                                {
                                  key: item.title,
                                  attrs: { avatar: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goTo(index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        flex: "",
                                        "align-center": "",
                                        "justify-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "title text--darken-2",
                                              attrs: { icon: "" }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(_vm._s(item.button))
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.title) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-sub-title",
                                            { staticClass: "sub-title-color" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.subtitle) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }